<template>
  <TheNumberLotteryPage>
    <NumberLotteryBasePlaySlip>
      <template #default="{ isDisabled, isVisible, play, updatePlays }">
        <NebraskaMyDayLotteryPlaySlipItem
          v-if="isVisible || !isDisabled"
          :key="play.id"
          v-bind="{
            defaultValue,
            play,
          }"
          :disabled="isDisabled"
          @play-state-changed="updatePlays"
        />
        <NebraskaMyDayLotteryPlaySlipSkeleton v-else />
      </template>

      <template #bottom>
        <LotteryBaseQuickPickButton @click="onQuickPick" />
      </template>
    </NumberLotteryBasePlaySlip>
  </TheNumberLotteryPage>
</template>

<script lang="ts" setup>
const { fillPlaysWithQuickPick, visiblePlayId } = usePlaySlip()

const { result } = useUserDataQuery()

const defaultValue = computed(() => {
  if (!result.value) return

  const [year, month, day] = result.value.player.dateOfBirth.split('-')
  return {
    day: parseInt(day) ?? null,
    month: parseInt(month) ?? null,
    year: parseInt(year.slice(-2)) ?? null,
  }
})

const onQuickPick = throttle(() => {
  fillPlaysWithQuickPick([visiblePlayId.value], {
    validateFn: validateQuickPick,
  })
}, 750)

const validateQuickPick: QuickPickOptions['validateFn'] = (numbers) =>
  isValidQuickPickDate(numbers[2][0], numbers[0][0], numbers[1][0])
</script>
